import { CheckCircle } from 'lucide-react'

export const SessionRecoveryIndicator = () => {
  return (
    <div className="bg-primary/10 border-b border-primary/20 animate-fade-in-down">
      <div className="container max-w-3xl mx-auto p-3 flex items-center gap-3 text-sm">
        <CheckCircle className="h-5 w-5 text-primary flex-shrink-0" />
        <p className="text-primary font-medium">
          Session Recovered. Ready to continue.
        </p>
      </div>
    </div>
  )
}
